module.exports = __webpack_public_path__ + "img/94.2.TN.6bad0791.png";